import Axios from 'axios';

import { config } from '@/config';

const axios = Axios.create({
  baseURL: config.api.base,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
  withCredentials: true,
  withXSRFToken: true,
});

// Modified request interceptor
axios.interceptors.request.use((request) => {
  const token = localStorage.getItem(config.api.token);
  // Only add Authorization header for non-S3 requests
  if (token && request.headers && request.baseURL?.startsWith(config.api.base)) {
    request.headers.Authorization = `Bearer ${token}`;
  }
  return request;
});

export const setAuthorizationToken = (token: string) => {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
};

export default axios;
